import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorageKey } from '@enums-global/enum-local-storage-key';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private _auth0Service: AuthService, private _http: HttpClient) {}

  logout(): void {
    localStorage.removeItem(LocalStorageKey.LAST_ACTIVE);
    const returnTo = `${new URL(window.location.href).origin}/login`;
    this._http
      .post(`${environment.api}/auth/logout`, {})
      .pipe(catchError(() => of(null)))
      .subscribe(() => {
        this._auth0Service.logout({
          logoutParams: { returnTo }
        });
      });
  }

  requestPasswordReset(email: string): Observable<any> {
    return this._http.post(
      `${environment.api}/public/auth/request-password-reset`,
      {
        email
      }
    );
  }
}
